module.exports = __webpack_public_path__ + "img/46.5bf07c9b.jpg";